export default "__VITE_ASSET__C2iHVpeU__"